import React from 'react';

const getHeight = (s, w, h) => (parseInt(s, 10) / w) * h + 'px';

export function Filter(props) {
  const fill = props.fill || 'black';
  const size = props.size || '24px';

  return (
    <svg width={size} height={getHeight(size, 13, 13)} viewBox="0 0 13 13">
      <path
        fill={fill}
        fillRule="evenodd"
        d="M3.783 10.696a.646.646 0 0 1-.653-.653c0-.365.287-.652.653-.652.365 0 .652.287.652.652a.646.646 0 0 1-.652.653m7.565-1.305H5.635a1.955 1.955 0 0 0-1.852-1.304c-.861 0-1.566.548-1.853 1.304H.652a.646.646 0 0 0-.652.652c0 .366.287.653.652.653H1.93c.261.756.992 1.304 1.853 1.304.86 0 1.565-.548 1.852-1.304h5.713a.646.646 0 0 0 .652-.653.646.646 0 0 0-.652-.652M7.565 6c0-.365.287-.652.652-.652.366 0 .653.287.653.652a.646.646 0 0 1-.653.652A.646.646 0 0 1 7.565 6M0 6c0 .365.287.652.652.652h5.713c.261.757.992 1.305 1.852 1.305.861 0 1.566-.548 1.853-1.305h1.278A.646.646 0 0 0 12 6a.646.646 0 0 0-.652-.652H10.07a1.955 1.955 0 0 0-1.853-1.305c-.86 0-1.565.548-1.852 1.305H.652A.646.646 0 0 0 0 6m3.783-3.391a.646.646 0 0 1-.653-.652c0-.366.287-.653.653-.653.365 0 .652.287.652.653a.646.646 0 0 1-.652.652m7.565-1.305H5.635A1.955 1.955 0 0 0 3.783 0C2.922 0 2.217.548 1.93 1.304H.652A.646.646 0 0 0 0 1.957c0 .365.287.652.652.652H1.93c.261.756.992 1.304 1.853 1.304.86 0 1.565-.548 1.852-1.304h5.713A.646.646 0 0 0 12 1.957a.646.646 0 0 0-.652-.653"
      />
    </svg>
  );
}

export function Printer(props) {
  const fill = props.fill || '#202020';
  const size = props.size || '24px';

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 13C19.2652 13 19.5195 13.1054 19.707 13.293C19.8946 13.4805 20 13.7348 20 14V23C20 23.2652 19.8946 23.5195 19.707 23.707C19.5195 23.8946 19.2652 24 19 24H5C4.73478 24 4.4805 23.8946 4.29297 23.707C4.10543 23.5195 4 23.2652 4 23V14C4 13.7348 4.10543 13.4805 4.29297 13.293C4.4805 13.1054 4.73478 13 5 13H19ZM6 22H18V15H6V22ZM17 19V21H7V19H17ZM19 0C19.2652 0 19.5195 0.105433 19.707 0.292969C19.8946 0.480505 20 0.734784 20 1V5H23C23.2652 5 23.5195 5.10543 23.707 5.29297C23.8946 5.4805 24 5.73478 24 6V18C24 18.2652 23.8946 18.5195 23.707 18.707C23.5195 18.8946 23.2652 19 23 19H21V17H22V7H2V17H3V19H1C0.734784 19 0.480505 18.8946 0.292969 18.707C0.105433 18.5195 0 18.2652 0 18V6C0 5.73478 0.105432 5.4805 0.292969 5.29297C0.480505 5.10543 0.734784 5 1 5H4V1C4 0.734784 4.10543 0.480505 4.29297 0.292969C4.4805 0.105432 4.73478 0 5 0H19ZM17 18H7V16H17V18ZM19 8C19.5523 8 20 8.44771 20 9C20 9.55228 19.5523 10 19 10C18.4477 10 18 9.55228 18 9C18 8.44771 18.4477 8 19 8ZM6 5H18V2H6V5Z" fill={fill}/>
    </svg>
  );
}

export function Envelope(props) {
  const fill = props.fill || '#202020';
  const size = props.size || '24px';

  return (
    <svg width={size} height={getHeight(size, 24, 17)} viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 0C22.912 0 24 0.400008 24 2.33301V15C24 15.5304 23.7891 16.039 23.4141 16.4141C23.039 16.7891 22.5304 17 22 17H2C1.46957 17 0.96101 16.7891 0.585938 16.4141C0.210865 16.039 0 15.5304 0 15V2.33301C0 0.400008 1.088 0 2 0H22ZM2 2.33301V15H22V2.33301C22 2.24501 22.0002 2.104 21.9902 2H2.00977C1.99977 2.1 2 2.24501 2 2.33301ZM12 8.84766L19.3721 4.63574L20.3643 6.37207L12.4961 10.8721C12.3447 10.9571 12.1736 11.0011 12 11C11.8247 11.0006 11.6522 10.9552 11.5 10.8682L3.63184 6.36816L4.62402 4.63184L12 8.84766Z" fill={fill}/>
    </svg>
  );
}

export function Cross(props) {
  const fill = props.fill || 'black';
  const size = props.size || '24px';

  return (
    <svg width={size} height={getHeight(size, 24.8, 25.8)} viewBox="0 0 24.8 24.8">
      <path fill={fill} d="M.03 1.58L1.58.03l23.27 23.26-1.56 1.55z" />
      <path fill={fill} d="M23.22.03l1.55 1.55L1.51 24.85l-1.56-1.56z" />
    </svg>
  );
}
